module.exports = __webpack_public_path__ + "img/default-avatar.d2c893f5.png";